import http from "../api/http";

export const COOKIE_NAME_TOKEN = "token";
export const COOKIE_NAME_TOKEN_FINGERPRINT = "token_fgp";
export const COOKIE_NAME_REDIRECT_URI = "redirect_uri";
export const COOKIE_NAME_TOKEN_PLUS = "token_plus";


import VueCookies from 'vue-cookies';
import localforage from 'localforage';

export function clearSessionCookies() {
  const config =  http.config;
  if (config) {
    VueCookies.remove(COOKIE_NAME_REDIRECT_URI, null, config.COOKIE_DOMAIN);
    VueCookies.remove(COOKIE_NAME_TOKEN, null, config.COOKIE_DOMAIN);
    VueCookies.remove(COOKIE_NAME_TOKEN_FINGERPRINT, null, config.COOKIE_DOMAIN);
    VueCookies.remove(COOKIE_NAME_TOKEN_PLUS, null, config.COOKIE_DOMAIN);
  }
  VueCookies.remove(COOKIE_NAME_REDIRECT_URI);
  VueCookies.remove(COOKIE_NAME_TOKEN);
  VueCookies.remove(COOKIE_NAME_TOKEN_FINGERPRINT);
  VueCookies.remove(COOKIE_NAME_TOKEN_PLUS);
  localforage.createInstance({ driver: localforage.INDEXEDDB, name: 'masterData' }).clear();
}

export function removeCookie(cookieName) {
  const config =  http.config;
  if (config) {
    VueCookies.remove(cookieName, null, config.COOKIE_DOMAIN);
  }
  VueCookies.remove(cookieName);
}
